/* eslint-disable jsx-a11y/anchor-is-valid */
import { Grid, TextField, Typography } from '@mui/material';

// eslint-disable-next-line import/no-extraneous-dependencies
import ScrollContainer from 'react-indiana-drag-scroll';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { Image } from '@mui/icons-material';
import { images } from '../../../../assets';
import { globalWindow, notifyMessages } from '../../../../core/constant';
import notify from '../../../../utils/notify';
import LoginSignInDialog from '../../../dialogs/JoinOrSignIn';
import { SubLiNav } from './SubLiNav';
import DarkBtn from '../../Buttons/DarkBtn';
import VerticalTabs from '../../HeaderTab';

export const DesktopViewHeader = ({ headerData, search, setSearch, searchQuery, userDetails }) => {
  const { pathname } = useLocation();

  return (
    <div className="mainsection mobilehide">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div
          tabIndex={0}
          role="button"
          onClick={() => {
            if (pathname.includes('personalize') && !userDetails?.user?.is_completed_seller) {
              notify(notifyMessages?.completePersonalization, 'error');
              return;
            }
            globalWindow.location.href = `${process.env.REACT_APP_USER_APP_URL}`;
          }}
          className="mainlogodiv"
        >
          <img src={images?.mainLogo} alt="top bar" className="mainlogo" />
        </div>
        {!pathname.includes('personalize') && (
          <div className="mainmenu">
            {userDetails?.token ? (
              <div className="navbar">
                <div className="subnav subnavbtn">
                  <Link href="/dashboard" to="/dashboard" className="menumaintext">
                    Dashboard
                  </Link>
                </div>
                <div className="subnav subnavbtn">
                  <Link
                    href={`${process.env.REACT_APP_USER_APP_URL}artist/${userDetails?.user?.v_fname}-${userDetails?.user?.v_lname}/${userDetails?.user?.id}`}
                    to={`${process.env.REACT_APP_USER_APP_URL}artist/${userDetails?.user?.v_fname}-${userDetails?.user?.v_lname}/${userDetails?.user?.id}`}
                    className="menumaintext"
                  >
                    View Portfolio
                  </Link>
                </div>
                <div className="subnav subnavbtn">
                  <Link
                    href={`${process.env.REACT_APP_USER_APP_URL}match-maker`}
                    to={`${process.env.REACT_APP_USER_APP_URL}match-maker`}
                    className="menumaintext"
                  >
                    Explore
                  </Link>
                </div>
              </div>
            ) : (
              // <div className="navbar">
              //   <div className="subnav">
              //     <div>
              //       <Link
              //         href={`${process.env.REACT_APP_USER_APP_URL}search/artworks/search-all`}
              //         to={`${process.env.REACT_APP_USER_APP_URL}search/artworks/search-all`}
              //         className="menumaintext"
              //       >
              //         Buy Art
              //       </Link>
              //     </div>
              //     <div className="subnav-content">
              //       <Grid container spacing={2}>
              //         <Grid item xs={2}>
              //           <Link
              //             href={`${process.env.REACT_APP_USER_APP_URL}match-maker`}
              //             to={`${process.env.REACT_APP_USER_APP_URL}match-maker`}
              //           >
              //             Free Matchmaking Tool
              //           </Link>
              //         </Grid>
              //         <Grid item xs={10}>
              //           <ScrollContainer className="scroll-container">
              //             <div style={{ display: 'flex' }}>
              //               {headerData?.headerCategories?.map((item, index) => {
              //                 return (
              //                   <div className="subli" key={index}>
              //                     <Link
              //                       href={`${process.env.REACT_APP_USER_APP_URL}${item?.v_slug}`}
              //                       to={`${process.env.REACT_APP_USER_APP_URL}${item?.v_slug}`}
              //                       className="subachor"
              //                     >
              //                       {item?.v_name}
              //                     </Link>
              //                     <ScrollContainer className="scroll-container">
              //                       <SubLiNav headerData={headerData} item={item} />
              //                     </ScrollContainer>
              //                   </div>
              //                 );
              //               })}
              //             </div>
              //           </ScrollContainer>
              //         </Grid>
              //       </Grid>
              //     </div>
              //   </div>

              //   <div className="subnav subnavbtn">
              //     <Link href="/signup" to="/signup" className="menumaintext">
              //       Sell Art
              //     </Link>
              //   </div>

              //   <div className="subnav subnavbtn">
              //     <Link
              //       href={`${process.env.REACT_APP_USER_APP_URL}about-us`}
              //       to={`${process.env.REACT_APP_USER_APP_URL}about-us`}
              //       className="menumaintext"
              //     >
              //       About Us
              //     </Link>
              //   </div>
              // </div>

              <div className="mainmenu">
                <div className="navbar">
                  <div className="buy-art-section">
                    <div className="subnav subnavbtn">
                      <Link
                        href={`${process.env.REACT_APP_USER_APP_URL}search/artworks/search-all`}
                        to={`${process.env.REACT_APP_USER_APP_URL}search/artworks/search-all`}
                        className="menumaintext"
                      >
                        Buy Art
                      </Link>
                    </div>
                    <div className="buy-art-inner">
                      <div className="buy-art-menu">
                        <VerticalTabs headerData={headerData} />
                        <div className="last-section">
                          <Typography className="font16px">Try Our Free AI Powered Matchmaker</Typography>
                          <Link
                            href={`${process.env.REACT_APP_USER_APP_URL}match-maker`}
                            to={`${process.env.REACT_APP_USER_APP_URL}match-maker`}
                            className="menumaintext"
                          >
                            <DarkBtn title="Get Started" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="basket-icon">
                    <div className="subnav subnavbtn">
                      <Link href="/signup" to="/signup" className="menumaintext">
                        Sell Art
                      </Link>
                    </div>
                    <div className="cart-menu-inner">
                      <div className="cart-menu">
                        <Grid container spacing={2} className="item-center-text">
                          <Grid item xs={2.5}>
                            <Link href="/signup" to="/signup">
                              <img
                                src={headerData?.sellArts?.createAnAccount?.icon_image || images.createAccount}
                                alt="top bar"
                                className="create-account "
                              />
                            </Link>
                          </Grid>
                          <Grid item xs={9.5}>
                            <Typography className="font12px account-text">
                              <Link href="/signup" to="/signup">
                                {headerData?.sellArts?.createAnAccount?.title}
                              </Link>
                            </Typography>
                            <Typography className="font10px">
                              <Link href="/signup" to="/signup">
                                {headerData?.sellArts?.createAnAccount?.heading}
                              </Link>
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid container spacing={2} className="item-center-text">
                          <Grid item xs={2.5}>
                            <Link
                              href={`${process.env.REACT_APP_USER_APP_URL}about-us`}
                              to={`${process.env.REACT_APP_USER_APP_URL}about-us`}
                            >
                              <img
                                src={headerData?.sellArts?.howItWorks?.icon_image || images.works}
                                alt="top bar"
                                className="create-account "
                              />
                            </Link>
                          </Grid>
                          <Grid item xs={9.5}>
                            <Typography className="font12px account-text">
                              <Link
                                href={`${process.env.REACT_APP_USER_APP_URL}about-us`}
                                to={`${process.env.REACT_APP_USER_APP_URL}about-us`}
                              >
                                {headerData?.sellArts?.howItWorks?.title}
                              </Link>
                            </Typography>
                            <Typography className="font10px">
                              <Link
                                href={`${process.env.REACT_APP_USER_APP_URL}about-us`}
                                to={`${process.env.REACT_APP_USER_APP_URL}about-us`}
                              >
                                {headerData?.sellArts?.howItWorks?.heading}
                              </Link>
                            </Typography>
                          </Grid>
                        </Grid>
                      </div>
                    </div>
                  </div>
                  <div className="subnav subnavbtn">
                    <Link to={`${process.env.REACT_APP_USER_APP_URL}about-us`} className="menumaintext">
                      About Us
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {!userDetails?.token && (
        <div className="mobilehide">
          <div className="topsearchdiv" style={{ position: 'relative' }}>
            <TextField
              placeholder="Search Art & Artists"
              type="text"
              className="topsearchbar"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter' && search) {
                  globalWindow?.open(searchQuery, '_blank');
                }
              }}
            />
            <Link
              href
              // href={search ? globalWindow?.open(searchQuery, '_blank') : 'javascript:;'}
              // to={search ? globalWindow?.open(searchQuery, '_blank') : 'javascript:;'}
              className="searchicon"
            >
              <div tabIndex={0} role="button" onClick={() => globalWindow?.open(searchQuery, '_blank')}>
                <img src={images.searchIcon} alt="search icon" className="searciconimg" />
              </div>
            </Link>
          </div>
        </div>
      )}

      <Grid item xs={1.4} sm={2} className="signbtnright">
        <LoginSignInDialog />
      </Grid>
      {!userDetails?.token && (
        <Grid item xs={1.6} sm={1} className="alignmentcart">
          <div className="carticontop">
            <Link href={`${process.env.REACT_APP_USER_APP_URL}cart`} to={`${process.env.REACT_APP_USER_APP_URL}cart`}>
              <img src={images.cartIcon} alt="carticon" className="valuecart" />
              <span className="valuecart">(0)</span>
            </Link>
          </div>
        </Grid>
      )}
    </div>
  );
};
